var map = {
	"./1.png": "XvqA",
	"./2.png": "kXFA",
	"./3.png": "XmS/",
	"./4.png": "kYLo",
	"./5.png": "1NJ4",
	"./6.png": "NSXP",
	"./dice.gif": "Gpb/"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/nhC";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/winter/dice ^\.\/.*$
// module id = /nhC
// module chunks = 2